import { Box } from '@material-ui/core'
import React from 'react'
import { GrAnnounce } from 'react-icons/gr'
import { HiInformationCircle } from 'react-icons/hi'
import { RiArticleLine } from 'react-icons/ri'

import { SectionContainer, SectionTitle, List, Tabs } from '../../_common'

import { lightTheme } from '../../../App.theme'

const DocumentosActualizados = () => {
  const comunicados = [
    { title: 'Unificación de Zonas Salariales', text: '' },
    { title: 'Deducción Pensiones y Jubilaciones', text: '' },
    { title: 'Nueva Norma NIF D-3', text: '' },
    {
      title: 'Disposiciones de la Nueva Ley de Impuesto sobre la Renta',
      text: '',
    },
    { title: 'Estadísticas de Registro', text: '' },
    { title: 'Nuevo Panorama para las Prestaciones en México', text: '' },
    { title: 'Comparativo NIF D-3 2015 y la nueva NIF D-3 2016', text: '' },
    { title: 'Nuevas Disposiciones de la CONSAR', text: '' },
    { title: 'Disposiciones de la SCJN sobre las Deducibilidad', text: '' },
  ]

  const articulos = [
    { title: 'Revista IMEF', text: '' },
    { title: 'NIF D-4', text: '' },
    { title: 'Estrategias Deterioradas – Valuación de Empresas', text: '' },
  ]

  const otros = [
    {
      title:
        'El envejecimiento de la población y su impacto en el Sector Asegurador',
      text: '',
    },
    { title: 'Para mayor información, consulta', text: '' },
    {
      title: 'Reforma Hacendaria –  Resolución Miscelánea Fiscal 2014',
      text: '',
    },
  ]

  return (
    <SectionContainer
      sectionID="documentosActualizados"
      backgroundColor={lightTheme.palette.background.extraLightOverlay}
    >
      <SectionTitle title="Documentos Actualizados" />
      <Box my={6}>
        <Tabs
          tabs={[
            {
              title: 'Comunicados',
              component: <List items={comunicados} />,
              icon: <GrAnnounce />,
              renders: true,
            },
            {
              title: 'Artículos',
              component: <List items={articulos} />,
              icon: <RiArticleLine />,
              renders: true,
            },
            {
              title: 'Otros',
              component: <List items={otros} />,
              icon: <HiInformationCircle />,
              renders: true,
            },
          ]}
        />
      </Box>
    </SectionContainer>
  )
}

export default DocumentosActualizados
